/*
 *
 * ApmSwitch
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 29-Jan-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import PortalSwitch from '@nexidigital/portalswitch'
import PortalMessage from 'Hoc/PortalMessage'
import { checkXmlSvg } from 'Utility/globalMethods'
import './ApmSwitch.scss'

const ApmSwitch = ({ logo, label, description, ...props }) => (
  <div className='apmSwitch_wrapper'>
    {!!logo && (
      <>
        {checkXmlSvg(logo) ? (
          <img
            id='apmSwitch_apmLogo'
            className='apmSwitch_apmLogo'
            src={`data:image/svg+xml;utf8,${encodeURIComponent(logo)}` || ''}
            alt={`${label} Logo` || ''}
          />
        ) : (
          <div className='card_notfound' />
        )}
      </>
    )}
    <div className='apmSwitch_toggle_wrapper'>
      <div className='apmSwitch_text'>
        <h3 className='apmSwitch_name'>{label}</h3>
        {!!description && (
          <p id='apmSwitch_apmDescription' className='popup_wrapper_description'>
            <PortalMessage id={description?.id || ''} defaultMessage={description?.defaultMessage || ''} />
          </p>
        )}
      </div>
      <PortalSwitch {...props} />
    </div>
  </div>
)

ApmSwitch.propTypes = {
  /** the APM label */
  label: PropTypes.string,
  /** the APM description */
  description: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  /** the APM logo */
  logo: PropTypes.string
}

ApmSwitch.defaultProps = {
  label: '',
  logo: ''
}

export default ApmSwitch
